<template>
  <div id="footer-section" class="footer-new">
    <div class="inner-bound">
      <!-- Brand & Contact -->
      <div class="footer-brand">
        <img src="/static/images/nicsrsLogo.png" alt="NicSRS" class="footer-logo" />
        <p>{{ t('footer.hotline') }}</p>
        <p>{{ t('footer.email') }}</p>
      </div>

      <!-- Navigation Columns -->
      <div class="footer-nav">
        <div class="footer-col" v-for="section in footerSections" :key="section.title">
          <h4>{{ section.title }}</h4>
          <NuxtLink v-for="link in section.links" :key="link.to" :to="localePath(link.to)">
            {{ link.label }}
          </NuxtLink>
        </div>
      </div>
    </div>

    <!-- Bottom Links & Social -->
    <div class="footer-bottom">
      <div class="inner-bound">
        <div class="footer-bottom-left">
          <!-- 首页展示 -->
          <template v-if="isHomePage">
            <a href="https://www.ssltrus.com">sslTrus.com</a>
            <a href="https://www.sslTrus.cn">sslTrus.cn</a>
            <a href="https://www.Racent.com">Racent.com</a>
            <a href="https://www.RubicForce.com">RubicForce.com</a>
            <a href="https://Sectigo.cn"> Sectigo.cn</a>
            <a href="https://www.linkedin.com/company/nicsrs/"> Linkined: https://www.linkedin.com/company/nicsrs/ </a>
          </template>
          <!-- 内页展示 -->
          <template v-else>
            <a href="https://www.ssltrus.com">sslTrus.com</a>
            <a href="https://www.Racent.com">Racent.com</a>
            <a href="https://www.RubicForce.com">RubicForce.com</a>
            <a href="https://www.linkedin.com/company/nicsrs/"> Linkined: https://www.linkedin.com/company/nicsrs/ </a>
          </template>
        </div>
        <div class="footer-bottom-right">
          <a href="https://www.linkedin.com/company/nicsrs/" class="footer-linkedin">LinkedIn</a>
          <div class="footer-social-icons">
            <a href="https://x.com/nicsrs" class="social-icon social-x" target="_blank" title="X"></a>
            <a
              href="https://instagram.com/nicsrs"
              class="social-icon social-instagram"
              target="_blank"
              title="Instagram"
            ></a>
            <a
              href="https://www.linkedin.com/company/nicsrs/"
              class="social-icon social-linkedin"
              target="_blank"
              title="LinkedIn"
            ></a>
            <a
              href="https://youtube.com/@nicsrs"
              class="social-icon social-youtube"
              target="_blank"
              title="YouTube"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const { t, tm, rt } = useI18n()
const localePath = useLocalePath()
const { plainTm } = usePlainTm()
const route = useRoute()

const isHomePage = computed(() => route.path === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/$/i.test(route.path))

const footerSections = computed(() => plainTm('footer.sections'))
</script>
